module.exports = __webpack_public_path__ + "static/media/caravan-alt.7d35742f.svg";